import styled from 'styled-components';

export const StyledUber = styled.div``;
